/**
 * Normalizes a value to an Error instance.
 * If the value is already an Error, it returns it as is.
 * @param value - The value to convert to an Error.
 * @returns An Error instance.
 */
export function toError(value: unknown): Error {
  if (value instanceof Error) {
    return value;
  }

  if (typeof value === 'string') {
    return new Error(value);
  }

  if (value !== undefined && value !== null && typeof value === 'object') {
    const err: Error = {
      name: 'name' in value && typeof value.name === 'string' ? value.name : 'UnknownError',
      message: 'message' in value && typeof value.message === 'string' ? value.message : 'An unknown error occurred',
      stack: 'stack' in value && typeof value.stack === 'string' ? value.stack : undefined,
    };
    return err;
  }

  return new Error(String(value));
}
